var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.742,
    height: 122.481,
    viewBox: "0 0 191.742 122.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-1624.794 -1327.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M2746.512,353.938a44.79,44.79,0,0,0-13.192,31.486h-14.669a2.048,2.048,0,0,0-2.042,2.042v15.827a1.927,1.927,0,0,1-3.386,1.265l-24.616-28.524-.009-.018a29.012,29.012,0,0,1-7.675-20.186c.274-15.951,13.617-28.594,29.576-28.594h42.565a29.022,29.022,0,0,1,20.574,8.514,29.441,29.441,0,0,1,3.919,4.874.081.081,0,0,1-.066.125,44.811,44.811,0,0,0-30.979,13.189",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M2834.014,347.812h-55.609a38,38,0,0,0-38.017,37.615v.4a38.02,38.02,0,0,0,38.017,38.017h44.96a2.655,2.655,0,0,1,2.666,2.652v20.689a2.512,2.512,0,0,0,4.415,1.652l32.171-37.267.015-.028a37.884,37.884,0,0,0,10.024-26.367c-.347-20.856-17.8-37.365-38.642-37.365m-51.679,46.973a8.525,8.525,0,1,1,8.525-8.525,8.527,8.527,0,0,1-8.525,8.525m24.188,0a8.525,8.525,0,1,1,8.525-8.525,8.527,8.527,0,0,1-8.525,8.525m24.187,0a8.525,8.525,0,1,1,8.525-8.525,8.527,8.527,0,0,1-8.525,8.525",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30);
export default __webpack_public_path__ + "static/media/Group 30.73da05b73cfa6e7c6ab2bc30e9e79f51.svg";
export { ForwardRef as ReactComponent };